module.exports = "./images/09_klarna-jobs.jpg";